import { FjdBaseLayout, FjdStack } from "@efast/fjd-react-components";
import { ReactNode } from "react";
import Header from "../Header/Header";
import "./Layout.css";
import LegalFooter from "../LegalFooter/LegalFooter";

interface LayoutProps {
  children: ReactNode | ReactNode[];
}

function Layout({ children }: LayoutProps) {
  return (
    <FjdBaseLayout stickyHeader={true} wideContent={false} footer={<LegalFooter></LegalFooter>} header={<Header></Header>}>
      <FjdStack className="layout">{children}</FjdStack>
    </FjdBaseLayout>
  );
}

export default Layout;
